import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetResponseRateReport state domain
 */

const selectWidgetResponseRateReportDomain = (state) =>
  state.get("widgetResponseRateReport", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectWidgetResponseRateReportDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectDivisionsRate = () =>
  createSelector(selectWidgetResponseRateReportDomain, (state) =>
    state.get("divisionsRate")
  )

const makeSelectWidgetResponseRateReport = () =>
  createSelector(selectWidgetResponseRateReportDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResponseRateReport
export { selectWidgetResponseRateReportDomain }
